export default __webpack_public_path__ + "dc5d9e7ea9d867fcd1167551522c0549.png";